// generated by genversion
export var version = '5.2.0';
//# sourceMappingURL=version.js.map